import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill"
import { ELifeCycleStatus } from "../enums/life-cycle-status";

export class MeasureMassif {
    @AutoMap()
    Code!: string;
    @AutoMap()
    SamplingID!: number;
    @AutoMap()
    SamplingTime?: Temporal.PlainTime;
    @AutoMap()
    Localisation?: string;
    @AutoMap()
    ScolaMaterial?: string;
    @AutoMap()
    PrelevementEffectue?: boolean;
    @AutoMap()
    IsCancelled!: boolean;
    @AutoMap()
    Observation?: string;
    @AutoMap()
    ProcessMesureTerrainCode?: string;
    @AutoMap()
    ReferenceEtiquette?: string
    @AutoMap()
    Status: ELifeCycleStatus = ELifeCycleStatus.NotCompletedAndNotPositioned;
    @AutoMap()
    Position!: number;
}